import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  CCloseButton,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { AppSidebarNav } from "./AppSidebarNav";
import { sygnet } from "../../assets/brand/sygnet";
import navigation from "./_nav";

import {
  setSidebarShow,
  toggleSidebarUnfoldable,
} from "../../features/seller/sellerUiSlice";

const AppSidebar = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sellerUi.sidebarShow);
  const unfoldable = useSelector((state) => state.sellerUi.sidebarUnfoldable);

  return (
    <CSidebar
      className="border-end"
      colorScheme="light"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch(setSidebarShow(visible));
      }}
    >
      <CSidebarHeader className="border-bottom">
        <CSidebarBrand
          to="/"
          className="d-flex align-items-center gap-2"
          style={{ textDecoration: "none" }}
        >
          {/* <img src={logo} alt="Logo" loading="lazy" height={50} className="sidebar-brand-full" /> */}
          {/* Logo Icon */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px", // reduced spacing
            }}
          >
            {/* Logo Box */}
            <div
              style={{
                width: "32px", // smaller box
                height: "32px",
                background: "var(--cui-sidebar-bg)",
                borderRadius: "12px", // smaller radius to match
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 6px 20px rgba(45, 58, 39, 0.25)",
                position: "relative",
              }}
            >
              {/* glowing border */}
              <div
                style={{
                  position: "absolute",
                  inset: "-2px",
                  background: "white",
                  borderRadius: "14px", // adjusted to match size
                  zIndex: -1,
                }}
              />
              <span
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: "21px", // smaller "S"
                }}
              >
                S
              </span>
            </div>

            {/* Brand Text */}
            <span
              style={{
                color: "#ffffff",
                fontWeight: 800,
                fontSize: "21px", // slightly smaller brand text
                letterSpacing: "-0.3px",
              }}
            >
              ScrapTrade
            </span>
          </div>

          <CIcon
            customClassName="sidebar-brand-narrow"
            icon={sygnet}
            height={32}
          />
        </CSidebarBrand>
        <CCloseButton
          className="d-lg-none"
          dark
          onClick={() => dispatch(setSidebarShow(false))}
        />
      </CSidebarHeader>
      <AppSidebarNav items={navigation} />
      {/* <CSidebarFooter className="border-top d-none d-lg-flex">
        <CSidebarToggler
          onClick={() =>
            dispatch(toggleSidebarUnfoldable())
          }
        />
      </CSidebarFooter> */}
    </CSidebar>
  );
};

export default React.memo(AppSidebar);
